import React, { Component } from 'react';
import { Button, RadioButtonGroup, RadioButton } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { Breadcrumb } from '../../../../components';
import { getByDmService, insertDmService, getDmService, updateDmService } from '../../../../services/Api';
import { SelectedProducts, SizeQuantity } from '../../../../components/agency/requests';
import KitProducts from '../../../../components/agency/requests/KitProducts';
import BriefingRequestProduct from '../../../../components/agency/requests/BriefingRequestProduct';
import UploadReference from '../../../../components/agency/requests/UploadReference';
import { Administrador, Consultor, Criacao, Interno, Supervisor } from '../../../../config/UserStatusLevel';
import { Devolvido, Triagem } from '../../../../config/StatusPedido';
// import { create } from 'lodash';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {},
      dataProduct: {},
      disabledButtonCart: false,
      calcPrice: "",
      finalPrice: 0,
      dataRequest: {},
      listRequest: [],
      isCarrinho: true,
      sizeOK: true,
      pendingStep: false,
      pendingStepBriefing: false,
      isKit: false,
      createText: null,
      excluido: false
    }
  }

  componentDidMount = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({ nivel, createText: null });

    await this.getItemsRequest()
    await this.implementListSizes()
  }

  getItemsRequest = async () => {
    const { match } = this.props;
    const { path, params } = match
    if (path === "/agencia/pedido/:id") {
      try {
        const dataRequest = await getDmService(`/Pedido/GetDetalheItemPedidoAgencia/${params.id}`);
        const { idGrupo, idProduto, idMaterial, idDetalhe, idItem } = await dataRequest
        const dataFilters = await getDmService(`/ProdutoAgencia/Busca/?IdGrupo=${idGrupo}&IdDescricao=${idProduto}&IdMaterial=${idMaterial}&IdDetalhe=${idDetalhe}&IdItem=${idItem}`);
        const obj = {
          dataRequest,
          dataProduct: {
            dataFilters
          },
          isCarrinho: dataRequest.idStatusPedido === 1,
          idStatusPedido: dataRequest.idStatusPedido,
          excluido: dataRequest.excluido
        }
        // console.log("getItemsRequest", obj)
        await this.setState(obj);
      } catch (error) {
        console.log(error);
      }
    } else {
      this.loadProduct();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { match } = this.props;
    const { dataRequest } = this.state;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    console.log('dataRequest');
    console.log(dataRequest);
    if (!existRequest) {
      if (nextProps.match.params.id !== match.params.id) {
        this.loadProduct(nextProps.match.params.id);
        // this.getProductsType(nextProps.match.params.id);
        this.setState({ dataProduct: {}, calcPrice: " " })
      }
    }
  }

  getSum = (total, num) => parseFloat(total) + parseFloat(num);

  sumValues = values => {
    const larg = values.map(item => (item.largura))
    const stature = values.map(item => (item.altura))
    const largValue = larg.reduce(this.getSum, 0);
    const statureValue = stature.sort((a, b) => b - a)[0];
    const objSum = { widthProp: largValue, heightProp: statureValue };
    return objSum;
  }

  implementListSizes = async () => {
    const { dataRequest, dataProduct } = this.state;
    const { localAplicacao, variaveisAplicacao } = dataRequest
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");

    if (existRequest) {
      const { detalhes } = dataRequest;
      const listRequest = detalhes.map((item, index) => ({
        id: index,
        quantityPerModel: item.quantidade,
        sizesInputed: item.tamanhos.map(obj => ({
          widthProp: obj.largura,
          heightProp: obj.altura
        })),
        sumSizes: this.sumValues(item.tamanhos),
        value: `Nome do produto ${index}`,
      }))

      if (listRequest.length) {
        this.setState({
          listRequest,
          dataProduct: {
            ...dataProduct,
            listSizes: listRequest
          }
        })
      }

      try {
        const dataApp = await getByDmService(`/Aplicacao`, localAplicacao);

        const listVariables = []
        if (dataApp.fracionado) {
          await listVariables.push({ id: listVariables.length + 1, label: "Fracionado", value: "fracionado" });
        }
        if (dataApp.sequencial) {
          await listVariables.push({ id: listVariables.length + 1, label: "Sequêncial", value: "sequencial" });
        }
        if (dataApp.unico) {
          await listVariables.push({ id: listVariables.length + 1, label: "Único", value: "unico" });
        }

        let idSelected = 0
        for (const item of listVariables) {
          if (item.id === variaveisAplicacao) {
            idSelected = item.id
          }
        }

        const selectedVariable = await listVariables[idSelected] || { id: null, label: null };

        this.setState({
          dataProduct: {
            ...dataProduct,
            variableSave: selectedVariable,
            listSizes: listRequest
          }
        })
      } catch (error) {
        console.log("erro ao verificar a variavel de aplicação")
      }
    }
  }

  loadProduct = async (id) => {
    const { match } = this.props;
    const urlId = match.params.id;
    const data = await getByDmService(`/ProdutoCategoria`, id || urlId);

    if (data.nome.includes("Kit Merchan")) {
      this.setState({
        product: { id: data.id, name: data.nome, description: data.descricao },
        isKit: true
      });
    } else {
      this.setState({
        product: { id: data.id, name: data.nome, description: data.descricao },
        isKit: false
      });
    }
  }

  // getProductsType = async () => {
  //   const { dataRequest } = this.props;
  //   const { idProduto } = dataRequest;
  //   try {
  //     const data = await getDmService(`/Produto/GetTipo/?id=${dataRequest.idGrupo}`);
  //     this.setState({
  //       data
  //     });
  //   } catch (error) {
  //     console.log(error)
  //   }
  // };

  saveStep = async (stepData, step) => {
    // console.log("stepData", stepData)
    const { dataProduct, dataRequest } = this.state;
    const data = stepData;

    if (step === 'briefing') {
      if (stepData) {
        const listSizes = stepData.listSizes.map((item, i) => (
          { ...dataProduct.listSizes[i], ...item }
        ))
        data.listSizes = listSizes
      }
      await this.setState({ pendingStepBriefing: false })
    } else if (step === 'SelectedProduct') {
      if (stepData.hasChanged)
        await this.setState({
          pendingStep: true,
          pendingStepBriefing: true,
          dataRequest: { ...dataRequest, detalhes: [], hasChanged: true },
          dataProduct: { ...dataProduct, listSizes: [] }
        })
    } else
      await this.setState({ pendingStep: false, dataRequest: { ...dataRequest, hasChanged: false } })

    await this.setState({ sizeOK: step !== 'SelectedProduct' })
    this.setState(prevState => ({
      dataProduct: { ...prevState.dataProduct, ...data }
    }), () => {
      if (step !== 'briefing')
        this.updatePrice()
    });
  }

  updatePrice = async () => {
    const { dataProduct, listRequest } = this.state;
    const { dataFilters, listSizes } = dataProduct;
    const price = dataFilters && dataFilters.precoReferencia ? dataFilters.precoReferencia : 0;
    const values = listSizes && listSizes.length ? listSizes : listRequest && listRequest.length ? listRequest : [];
    const existOthers = values.length && Object.prototype.hasOwnProperty.call(values[0], 'otherValues');
    const typeGlass = !existOthers ? values.length && Object.prototype.hasOwnProperty.call(values[0], 'sizesInputed')
      : values.length && Object.prototype.hasOwnProperty.call(values[0].otherValues, 'sizesInputed');

    let valueWidth = 0;
    let valueQuantity = 0;
    const unitMensurement = dataFilters && dataFilters.unidadeMedida ? dataFilters.unidadeMedida : 0;
    let valueHeigth = 0;
    let detalhes = [];
    let formData = {};
    if (values.length && !typeGlass) {
      for (const item of values) {
        const obj = Object.prototype.hasOwnProperty.call(item, 'otherValues') ? item.otherValues : item;
        valueQuantity = parseInt(obj.amountSize, 10);
        if (obj.value && obj.value.isAlturaVariavel) {
          valueHeigth = parseFloat(obj.heightSize);
          valueWidth = parseFloat(obj.widthSize);
        } else if (!obj.isAlturaVariavel) {
          const existValue = Object.prototype.hasOwnProperty.call(obj, "value");
          valueHeigth = existValue ? parseFloat(obj.value.altura) : parseFloat(obj.heightSize)
          valueWidth = existValue ? parseFloat(obj.value.largura) : parseFloat(obj.widthSize);
        } else {
          valueHeigth = parseFloat(obj.heightSize);
          valueWidth = parseFloat(obj.widthSize);
        }

        detalhes.push({
          Quantidade: valueQuantity,
          Altura: valueHeigth,
          Largura: valueWidth
        })
      }

      formData = {
        UnidadeMedida: unitMensurement,
        ValorReferencia: price,
        Detalhes: detalhes
      }
    }

    if (typeGlass) {
      detalhes = [];
      for (const item of values) {
        const obj = Object.prototype.hasOwnProperty.call(item, 'otherValues') ? item.otherValues : item;
        detalhes.push({
          Largura: parseFloat(obj.sumSizes.widthProp),
          Altura: parseFloat(obj.sumSizes.heightProp),
          Quantidade: parseInt(obj.quantityPerModel, 10)
        })
      }

      formData = {
        UnidadeMedida: unitMensurement,
        ValorReferencia: price,
        Detalhes: detalhes
      }
    }

    if (values.length) {
      try {
        const result = await insertDmService('/Pedido/CalcValorPedidoAgencia/', formData);
        this.setState({
          calcPrice: result.valorFormatado,
          finalPrice: parseFloat(result.valor)
        })
      } catch (error) {
        console.log(error);
        this.setState({
          calcPrice: "",
          finalPrice: parseFloat(0)
        })
      }
    }
  }

  uploadFileReferences = async idItem => {
    const { dataProduct } = this.state;
    await Promise.all(
      dataProduct.uploads.map(async file => {
        try {
          const data = new FormData();
          data.append('file', file);
          await insertDmService(`/Pedido/UploadArquivoReferencia/?IdItemPedido=${idItem}`, data);
        } catch (err) {
          toast.error(`Falha ao fazer upload: ${err.message}`);
        }
      }),
    );
  };

  updateToCart = async () => {
    await this.addToCart();
  }

  handleCreateTextChange = (value) => {
    this.setState({ createText: value !== undefined && value !== null ? Number(value) : null });
  };

  addToCart = async () => {
    const { history, match } = this.props;
    const { params, path } = match
    const {
      dataProduct,
      finalPrice,
      dataRequest,
      listRequest,
      isKit,
      createText
    } = this.state;

    const {
      idProuto,
      idMaterial,
      idDetalhe,
      LocalAplicacao,
    } = dataRequest;

    const {
      variableSave,
      dataFilters,
      listSizes,
      aplicationSave
    } = dataProduct;

    this.setState({ disabledButtonCart: true })

    const idProduct = dataFilters ? dataFilters.id : idProuto;
    const idMateria = dataFilters ? dataFilters.idMaterial : idMaterial;
    const idDetail = dataFilters ? dataFilters.idDetalhe : idDetalhe || 0;
    const idApplication = (aplicationSave && aplicationSave.id) || (dataFilters ? dataFilters.listaAplicacoes[0].id : LocalAplicacao);
    const validat = true;
    // const labelVariable = variableSave && variableSave.value ? variableSave.value : "";
    const labelVariable = variableSave && (variableSave.value ? variableSave.value : variableSave.label ? variableSave.label : "");
    const isGlass = labelVariable === "unico" || labelVariable === "fracionado" || labelVariable === "sequencial";

    const details = [];
    const formData = [];
    const listSizesInputed = listSizes && listSizes.length ? listSizes : listRequest || []
    const existOutraAplicacao = Object.prototype.hasOwnProperty.call(dataProduct, "requiredComplementSave");
    if (isKit) {
      listSizes.forEach((item, idx) => {
        const temp = dataRequest && dataRequest.detalhes && dataRequest.detalhes.length > idx ? dataRequest.detalhes[idx] : {};
        details.push({
          Id: temp.id || 0,
          Quantidade: item.produto.quantidadeMinima || (temp.quantidade || null),
          Briefing: item.texto ? item.texto : (temp.briefing || null),
          IdProdutoAgencia: item.produto.id,
          // TamanhoDescritivo: testExist ? item.otherValues.sizesInputed.descriptionSize : (item.sizesInputed && Object.prototype.hasOwnProperty.call(item.sizesInputed, "descriptionSize")) ? item.sizesInputed.descriptionSize : (temp.tamanhoDescritivo || null),
          Tamanhos: []
        });

        formData.push({
          IdProdutoAgencia: item.produto.id,
          IdMaterial: item.produto.idMaterial,
          IdDetalhe: item.produto.idDetalhe,
          LocalAplicacao: idApplication || (dataRequest.localAplicacao || 0),
          VariaveisAplicacao: variableSave && variableSave.id ? variableSave.id : (dataRequest.variaveisAplicacao || 0),
          Detalhes: details,
          ValorTotal: finalPrice || dataRequest.valorTotal,
          IdItemPedido: dataRequest.idItemPedido,
          OutraAplicacao: existOutraAplicacao ? dataProduct.requiredComplementSave : null
        });
      });

      const idEdit = path === "/agencia/pedido/:id" && params.id > 0;
      try {
        let data = null;
        if (!idEdit) {
          data = await insertDmService('/Pedido/AdicionaKitCarrinho', formData)
          if (dataProduct.uploads && dataProduct.uploads.length > 0) {
            await this.uploadFileReferences(data.idItemPedido);
          }
        }
        else {
          if (dataProduct.uploads && dataProduct.uploads.length > 0) {
            await this.uploadFileReferences(dataRequest.idItemPedido);
          }
          data = await updateDmService('/Pedido/EditaDetalheItemPedidoAgencia', params.id, formData);
        }

        if (idEdit) {
          await toast.success("O pedido foi atualizado com sucesso.");
          await history.goBack()
        } else {
          await toast.success("O pedido foi realizado com sucesso.");
          await history.push('/carrinho')
        }

      } catch (error) {
        this.setState({ disabledButtonCart: false })
        this.errorHandler(error);
        console.log(error);
      }

    } else {
      if (isGlass) {
        listSizesInputed.forEach((item, idx) => {
          const temp = dataRequest && dataRequest.detalhes && dataRequest.detalhes.length > idx ? dataRequest.detalhes[idx] : {};
          let list = Object.prototype.hasOwnProperty.call(item, "otherValues") ? item.otherValues.sizesInputed : item.sizesInputed;

          if (typeof list === 'undefined')
            list = temp.tamanhos;

          const quantiyPerModel =
            item.otherValues ?
              (item.otherValues.quantityPerModel
                ? parseInt(item.otherValues.quantityPerModel, 10) : 1)
              : item.quantityPerModel ? item.quantityPerModel : 1;
          const numberOfLeaves = list.length || 0;
          const brief = item.texto;
          const detailItem = [];

          list.forEach((element, idx2) => {

            const tam = temp && temp.tamanhos ? temp.tamanhos[idx2] : {};
            const { heightProp, widthProp } = element
            const propHeight = heightProp || tam.altura;
            const propWidth = widthProp || tam.largura;
            // console.log("y", dataProduct.dataFilters.listaTamanhos)
            detailItem.push({
              Altura: parseInt(propHeight, 10),
              Largura: parseInt(propWidth, 10),
              // IdTamanho: dataProduct.dataFilters.listaTamanhos[idx2].id,
              Id: temp.id ? temp.id : item.value && item.value.id ? item.value.id : (tam ? tam.id : 0),
            })
          });

          details.push({
            Quantidade: quantiyPerModel || (temp.quantidade || null),
            NroFolhas: numberOfLeaves || (temp.nroFolha || null),
            Id: temp.id || 0,
            Briefing: brief || (temp.briefing || null),
            Tamanhos: detailItem
          });
        });

      } else {
        listSizes.forEach((item, idx) => {
          const existOtherValues = Object.prototype.hasOwnProperty.call(item, "otherValues");
          const testExist = existOtherValues && Object.prototype.hasOwnProperty.call(item.otherValues, "sizesInputed") ? Object.prototype.hasOwnProperty.call(item.otherValues.sizesInputed, "descriptionSize") : !validat
          let Altura = item.value && item.value.altura ? item.value.altura : typeof item.otherValues === 'undefined' ? 0 : parseFloat(item.otherValues.heightSize);
          let Largura = item.value && item.value.largura ? item.value.largura : typeof item.otherValues === 'undefined' ? 0 : parseFloat(item.otherValues.widthSize);
          console.log("item", item)
          if (typeof item.heightSize !== 'undefined')
            Altura = parseFloat(item.heightSize);
          else if (existOtherValues && item.otherValues.heightSize)
            Altura = parseFloat(item.otherValues.heightSize);

          if (typeof item.widthSize !== 'undefined')
            Largura = parseFloat(item.widthSize);
          else if (existOtherValues && item.otherValues.widthSize)
            Largura = parseFloat(item.otherValues.widthSize);

          const quantityPerSize =
            item.otherValues && item.otherValues.amountSize
              ? parseInt(item.otherValues.amountSize, 10)
              : item.amountSize ? parseInt(item.amountSize, 10)
                : null;
          const temp = dataRequest && dataRequest.detalhes && dataRequest.detalhes.length > idx ? dataRequest.detalhes[idx] : {};
          const tam = temp.tamanhos ? temp.tamanhos[0] : {};
          details.push(
            {
              Id: temp.id || 0,
              Quantidade: quantityPerSize || (temp.quantidade || null),
              Briefing: item.texto ? item.texto : (temp.briefing || null),
              TamanhoDescritivo: testExist ? item.otherValues.sizesInputed.descriptionSize : (item.sizesInputed && Object.prototype.hasOwnProperty.call(item.sizesInputed, "descriptionSize")) ? item.sizesInputed.descriptionSize : (temp.tamanhoDescritivo || null),
              Tamanhos: [
                {
                  Id: temp.id,
                  IdTamanho: item.value && item.value.idTamanho ? item.value.idTamanho : item.value.id ? item.value.id : (tam ? tam.idTamanho : 0),
                  Altura: Altura || tam.altura || 0,
                  Largura: Largura || tam.largura || 0
                }
              ]
            }
          )
        })
      }

      // eslint-disable-next-line no-shadow
      const formData = {
        IdProdutoAgencia: idProduct || dataRequest.idProduto,
        IdMaterial: idMateria,
        IdDetalhe: idDetail,
        LocalAplicacao: idApplication || (dataRequest.localAplicacao || 0),
        VariaveisAplicacao: variableSave && variableSave.id ? variableSave.id : (dataRequest.variaveisAplicacao || 0),
        Detalhes: details,
        ValorTotal: finalPrice || dataRequest.valorTotal,
        IdItemPedido: dataRequest.idItemPedido,
        OutraAplicacao: existOutraAplicacao ? dataProduct.requiredComplementSave : null,
        CriarTexto: createText !== undefined && createText !== null ? Number(createText) : null
      }

      const idEdit = path === "/agencia/pedido/:id" && params.id > 0;
      console.log("formData", formData);

      try {
        let data = null;
        if (!idEdit) {
          data = await insertDmService('/Pedido/AdicionaProdutoAgenciaCarrinho', formData)
          if (dataProduct.uploads && dataProduct.uploads.length > 0) {
            await this.uploadFileReferences(data.idItemPedido);
          }
        }
        else {
          if (dataProduct.uploads && dataProduct.uploads.length > 0) {
            await this.uploadFileReferences(dataRequest.idItemPedido);
          }
          data = await updateDmService('/Pedido/EditaDetalheItemPedidoAgencia', params.id, formData);
        }

        if (idEdit) {
          await toast.success("O pedido foi atualizado com sucesso.");
          await history.goBack()
        } else {
          await toast.success("O pedido foi realizado com sucesso.");
          await history.push('/carrinho')
        }

      } catch (error) {
        this.setState({ disabledButtonCart: false })
        this.errorHandler(error);
        console.log(error);
      }
    }
  }

  errorHandler = err => {
    const existError = Object.prototype.hasOwnProperty.call(err, "error");
    const existResponse = existError ? Object.prototype.hasOwnProperty.call(err.error, "response") : false;
    const existData = existResponse ? Object.prototype.hasOwnProperty.call(err.error.response, "data") : false;
    if (err.error && existError && existResponse && existData && typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } if (err.message)
      toast.error(err.message);
    else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

      renderCreateText = () => {
      const { createText } = this.state;
      return (
        <React.Fragment>
          <div className='radio-input'>
            <p className='color-red'><b>Este pedido envolve a criação ou revisão de texto?</b></p>
            <div className="inline-radio">
              <RadioButtonGroup
                legendText="Radio button heading"
                name="CriarTexto"
                valueSelected={createText}
                onChange={value => this.setState({ createText: Number(value) })}
              >
                <RadioButton
                  value={1}
                  labelText="Sim"
                  id="radio-1"
                />
                <RadioButton
                  value={0}
                  labelText="Não"
                  id="radio-2"
                />
              </RadioButtonGroup>
            </div>
          </div>
        </React.Fragment>
      );
    };
    
  render() {
    const {
      product,
      dataProduct,
      disabledButtonCart,
      calcPrice,
      dataRequest,
      nivel,
      idStatusPedido,
      isCarrinho,
      sizeOK,
      pendingStep,
      pendingStepBriefing,
      isKit,
      excluido,
    } = this.state;

    const { match, history } = this.props;
    const { path } = match;
    const urlId = match.params.id;
    const validate = true;
    const uploadedOk = dataProduct.dataFilters && dataProduct.dataFilters.uploadReferencia
      ? (dataProduct.uploads ? validate : !validate)
      : validate;
    const existSizes = dataProduct && Object.prototype.hasOwnProperty.call(dataProduct, 'listSizes')
      && dataProduct.listSizes.length ? validate : !validate;
    const productOk = dataProduct && dataProduct.productSave && Object.keys(dataProduct.dataFilters).length ? validate : !validate
    const sizeQuantiyOk = dataProduct && existSizes && sizeOK ? validate : !validate;

    const validatProduct = dataProduct && dataProduct.found ? !validate : validate;

    const existDatafilters = Object.prototype.hasOwnProperty.call(dataProduct, 'dataFilters');
    const briefingOptional = existDatafilters ? dataProduct.dataFilters.briefing : validate;
    const textInBriefing = (dataProduct.listSizes && dataProduct.listSizes.length > 0 && dataProduct.listSizes[0].texto ? validate : !validate);
    const briefingOk = !briefingOptional || textInBriefing

    const briefingValidate = briefingOk || !briefingOptional;

    const blockButton = sizeQuantiyOk
      && productOk
      && briefingValidate
      && uploadedOk
      && !disabledButtonCart;

    const existRequest = path === "/agencia/pedido/:id" && Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    const blockedUpload = existRequest ? false : briefingValidate && existSizes ? !validate : validate;
    const loadedComponents = existRequest || path !== "/agencia/pedido/:id";
    const disableSize = existRequest ? false : validatProduct;
    // const verifyDisable = sizeQuantiyOk ? !validate : validate;
    // const disableBriefing = isCarrinho ? false : verifyDisable;
    const disable = !isCarrinho && !(([Administrador, Interno].indexOf(nivel) > -1) || ([Consultor, Supervisor].indexOf(nivel) > -1 && [Devolvido, Triagem].indexOf(idStatusPedido) > -1));
    const tempDisable = !([Administrador, Interno].indexOf(nivel) > -1 || [Administrador, Consultor, Supervisor, Interno].indexOf(nivel) > -1) && [Devolvido, Triagem].indexOf(idStatusPedido) > -1;
    const userValues = JSON.parse(localStorage.getItem("user"));
    const permissionForAgency = userValues.agencia;
    const permission = !isCarrinho && !permissionForAgency;

  

    // Verificação condicional para mostrar renderCreateText

    return (
      <div>
        <Breadcrumb
          title={product.name || "Detalhe do item"}
          description={product.description}
          renderLeft={(
            <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          )}
        />
        <div className="center-box">
          {loadedComponents && (
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-md-12">
                <SelectedProducts
                  urlId={urlId}
                  product={product}
                  {...this.props}
                  saveStep={this.saveStep}
                  dataRequest={dataRequest}
                  dataProduct={dataProduct}
                  disabled={false}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-12">
                {isKit && product.name.includes("Kit Merchan") ? (
                  <KitProducts
                    {...this.props}
                    dataProduct={dataProduct}
                    saveStep={this.saveStep}
                    isFinished={pendingStep ? false : (sizeQuantiyOk || existRequest)}
                    disabledCard={![Criacao, Administrador, Interno].includes(nivel) && (disableSize || disable || permission)}
                    dataRequest={dataRequest}
                  />
                ) : (
                  <SizeQuantity
                    {...this.props}
                    dataProduct={dataProduct}
                    saveStep={this.saveStep}
                    isFinished={pendingStep ? false : (sizeQuantiyOk || existRequest)}
                    disabledCard={![Criacao, Administrador, Interno].includes(nivel) && (disableSize || disable || permission)}
                    dataRequest={dataRequest}
                  />
                )}
              </div>
              <div className="bx--col-xs-12 bx--col-md-12">
                <BriefingRequestProduct
                  {...this.props}
                  urlId={urlId}
                  dataProduct={dataProduct}
                  isFinished={pendingStepBriefing ? false : (textInBriefing || existRequest)}
                  saveStep={this.saveStep}
                  // disabledCard={disableBriefing || disable || permission}
                  disabledCard={tempDisable}
                  dataRequest={dataRequest}
                  isKit={isKit}
                  onCreateTextChange={this.handleCreateTextChange}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-12">
                <UploadReference
                  {...this.props}
                  dataProduct={dataProduct}
                  saveStep={this.saveStep}
                  disabledCard={blockedUpload || disable || permission}
                  dataRequest={dataRequest}
                />
              </div>
              <div className="bx--col-xs-12  v-md-margin">
                {existRequest ? (
                  <div>
                    {(!excluido && (isCarrinho || (([Administrador, Interno].indexOf(nivel) > -1) || ([Consultor, Supervisor].indexOf(nivel) > -1 && [Devolvido].indexOf(idStatusPedido) > -1))) && !permission) && (
                      <button
                        type="button"
                        className="bx--btn btn-full btn-secondary-color"
                        disabled={pendingStep}
                        onClick={() => this.updateToCart()}
                      >
                        ATUALIZAR PEDIDO
                        {` ${calcPrice}`}
                      </button>
                      // <Button
                      //   className="btn-full"
                      //   disabled={pendingStep}
                      //   onClick={() => this.updateToCart()}
                      // >
                      //   ATUALIZAR PEDIDO
                      //   {` ${calcPrice}`}
                      // </Button>
                    )}
                  </div>
                ) : (
                  <Button
                    className="bx--btn btn-full btn-secondary-color"
                    onClick={() => this.addToCart()}
                    disabled={!blockButton}
                  >
                    ADICIONAR AO CARRINHO
                    {` ${calcPrice}`}
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/client/agency/requests/Edit.js